import { render } from "./RemovePermissionCourse.vue?vue&type=template&id=3dfb06d6&scoped=true"
import script from "./RemovePermissionCourse.vue?vue&type=script&lang=js"
export * from "./RemovePermissionCourse.vue?vue&type=script&lang=js"

import "./RemovePermissionCourse.vue?vue&type=style&index=0&id=3dfb06d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfb06d6"]])

export default __exports__